export default "__VITE_ASSET__2c378be9__"